<div class="cmps-cdk-mb-1">
    <cmps-transcript-dialog-focus></cmps-transcript-dialog-focus>
</div>
<div
    class="cmps-cdk-mb-1"
    *ngIf="_service.state?.summaryEnabled === true"
>
    <cmps-transcript-dialog-summary></cmps-transcript-dialog-summary>
</div>
<div
    class="cmps-cdk-border-radius-4p cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-grey-300 cmps-cdk-mb-1"
    *ngIf="
        _service.state?.evaluationEnabled === true &&
        _service.state?.transcript?.caResult != null
    "
>
    <div class="cmps-cdk-m-0dot5">
        <div class="cmps-cdk-mb-0dot5">
            <cmps-ca-score-section
                [scorePercent]="
                    _service.state?.transcript?.caResult?.scorePercent
                "
            ></cmps-ca-score-section>
        </div>
        <div class="cmps-cdk-mb-0dot5">
            <cmps-ca-evaluation
                [caResult]="_service.state?.transcript?.caResult"
                [collapsed]="true"
                #eval
            ></cmps-ca-evaluation>
        </div>
        <div class="cmps-cdk-d-flex cmps-cdk-justify-content-center">
            <button
                class="cmps-cdk-color-blue-100 not:disabled:hover:cmps-cdk-bg-color-blue-100 not:disabled:focus:cmps-cdk-bg-color-blue-100 not:disabled:hover:cmps-cdk-color-white not:disabled:focus:cmps-cdk-color-white not:disabled:hover:cmps-cdk-pseudo-child not:disabled:focus:cmps-cdk-pseudo-child"
                cmpsOutlineButton
                (click)="
                    eval.collapsed = eval.atLeastOneCollapsed
                        ? false
                        : !eval.collapsed
                "
            >
                <span
                    cmpsOutlineButtonLabel
                    *ngIf="eval.atLeastOneCollapsed"
                    >{{ _i18n._11207_SEE_FULL_RESULTS | translate }}</span
                >
                <span
                    cmpsOutlineButtonLabel
                    *ngIf="!eval.atLeastOneCollapsed"
                    >{{ _i18n._11222_COLLAPSE_RESULTS | translate }}</span
                >
            </button>
        </div>
    </div>
</div>
<div class="cmps-cdk-d-flex cmps-cdk-justify-content-flex-end">
    <button
        class="cmps-cdk-border-color-blue-100 cmps-cdk-color-blue-100 not:disabled:hover:cmps-cdk-bg-color-blue-100 not:disabled:focus:cmps-cdk-bg-color-blue-100 not:disabled:hover:cmps-cdk-color-white not:disabled:focus:cmps-cdk-color-white not:disabled:hover:cmps-cdk-pseudo-child not:disabled:focus:cmps-cdk-pseudo-child"
        cmpsOutlineButton
        (click)="_onCreateNotesClick()"
    >
        <cmps-icon
            class="cmps-cdk-fill-blue-100 not:disabled:hover:cmps-cdk-fill-white not:disabled:focus:cmps-cdk-fill-white"
            svgIcon="note-edit-outline"
        ></cmps-icon>
        <span cmpsOutlineButtonLabel>{{
            _i18n._11208_CREATE_NOTES | translate
        }}</span>
    </button>
</div>
